import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, share, tap, mapTo } from 'rxjs/operators';

import { CatchError } from './helpers';
import { LoggerService } from './logger.service';
import { MailingListDetailModel } from './model/mailing-list-detail.model';
import { MailingListModel } from './model/mailing-list.model';
import { WizardService } from './wizard/wizard.service';
import { IMailingList } from './model/mailing-list.interface';
import { AppSettings } from 'pac-api';
import { GenericErrorHandlerService } from './shared/generic-error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class MailingListService {

  private Lists: MailingListModel[] = null;

  constructor(
    private http: HttpClient,
    private settings: AppSettings,
    private genericErrorHandler: GenericErrorHandlerService,
    private logger: LoggerService
  ) {
  }

  public GetMailingLists(type: string): Observable<MailingListModel[]> {
    if (this.Lists) {
      return of(this.Lists);
    }

    const observable = this.http.get(
      this.settings.pac_base_nf_url + 'api/MailingList/' + type,
      {
        withCredentials: true
      });

    const shared = observable.pipe(catchError(CatchError)).pipe(map((result: any) => {
      if (result.error) {
        return result;
      } else if (result instanceof Array) {
        return result.map(item => new MailingListModel(item));
      }
    }), share());

    shared.subscribe(result => {
      try {
        this.logger.info(result);
        this.Lists = result
      } catch { }
    }, this.genericErrorHandler.Hanlder);

    return shared;
  }

  public GetMailingListDetails(type: string): Observable<MailingListDetailModel[]> {
    const observable = this.http.post(
      this.settings.pac_base_nf_url + 'api/MailingList/' + type,
      {},
      {
        withCredentials: true
      });

    const shared = observable.pipe(catchError(CatchError)).pipe(map((result: any) => {
      if (result.error) {
        return result;
      } else if (result instanceof Array) {
        return result.map(item => new MailingListDetailModel(item));
      }
    }), share());

    shared.subscribe(result => {
      try {
        this.logger.info(result);
      } catch { }
    }, this.genericErrorHandler.Hanlder);

    return shared;
  }

  public AddMailingListDetails(list: IMailingList): Observable<MailingListDetailModel> {
    return this.http.put(this.settings.pac_base_nf_url + 'api/MailingList/' + list.mls_key, {}, { withCredentials: true }).pipe(
      catchError(CatchError),
      map((result: any) => {
        if (result.error) {
          return result;
        } else if ('mld_key' in result) {
          return new MailingListDetailModel(result);
        }
      }),
      tap(result => {
        try {
          this.logger.info(result);
        } catch { }
      }, this.genericErrorHandler.Hanlder)
    );
  }

  public RemoveMailingListDetails(list: IMailingList): Observable<boolean> {
    return this.http.delete(this.settings.pac_base_nf_url + 'api/MailingList/' + list.mls_key, { withCredentials: true }).pipe(
      catchError(CatchError),
      mapTo(true),
      tap({ error: this.genericErrorHandler.Hanlder})
    );
  }
}
